import type { CategoryContent } from '../../row.js';

/** Centraal-Aziatische geschiedenis, tweede reeks. Juiste antwoord staat eerst; wordt bij het bouwen gerandomiseerd. */
export const MORE_CENTRAL_ASIA: CategoryContent = {
  msc: [
    [
      'Waar staat het Kushanrijk vooral voor bekend?',
      [
        'Het verbinden van de Indiase, Iraanse en Chinese wereld, en het bevorderen van Gandhara-boeddhistische kunst',
        'Het vernietigen van de Grieks-Bactrische koninkrijken en het verdrijven van Hellenistisch bestuur uit het oosten',
        'Het invoeren van het zoroastrisme als staatsgodsdienst in heel Transoxanië',
        'Het stichten van het eerste sedentaire Turkse rijk ten noorden van de Syr Darja',
      ],
      0,
      'De munten van Kanishka tonen Griekse, Iraanse en Indiase goden naast elkaar, wat je moeilijk directer kunt uitdrukken over de positie van het rijk.',
    ],
    [
      'Boechara en Samarkand waren centra van welke dynastie in de negende en tiende eeuw?',
      [
        'De Samaniden',
        'De Ghaznaviden, die vanuit Ghazna in het huidige Afghanistan regeerden',
        'De Qarakhaniden, met hun basis in de Semirjetsjje',
        'De Buwayhiden, wier macht in West-Iran lag',
      ],
      0,
      'Aan het Samanidische hof begint de Nieuw-Perzische literatuur - Rudaki, en het milieu waaruit Ferdowsi putte.',
    ],
    [
      'In welke eeuw werd de Zijderoutestad Merv verwoest?',
      ['De dertiende', 'De elfde', 'De vijftiende', 'De negende'],
      0,
      'Geplunderd door Tolui in 1221. Het was een van de grootste steden van de wereld geweest en heeft die positie nooit meer teruggekregen.',
    ],
    [
      'Welk gebied besloeg het Chagatai-khanaat?',
      [
        'Transoxanië en het Tarimbekken, tussen de Gouden Horde en de Yuan',
        'De Pontische en Kaspische steppe west van de Oeral',
        'Iran en Irak, na de val van het Abbasidische kalifaat',
        'Mongolië zelf, samen met de Mantsjoerijse grensstreek',
      ],
      0,
      'De latere splitsing in een westelijke en oostelijke helft is de omgeving waaruit Timoer voortkwam, en het Chagatai-Turks werd een literaire taal op zichzelf.',
    ],
    [
      'Welke dynastie verdrongen de Oezbeekse Sjaybaniden in Transoxanië?',
      [
        'De Timoeriden',
        'De Safaviden, die Boechara kort hadden geannexeerd',
        'De Qarakhaniden, toen al in hun laatste verval',
        'De khanaten die de Gouden Horde aan de benedenloop van de Wolga opvolgden',
      ],
      0,
      'Mohammed Sjaybani nam Samarkand in 1500 in. Babur, van zijn erfenis beroofd, trok zuidwaarts en stichtte in plaats daarvan het Mogolrijk.',
    ],
    [
      'Wat was de jam?',
      [
        'Het Mongoolse postnet van pleisterplaatsen en verse paarden',
        'De schattingsheffing opgelegd aan veroverde sedentaire bevolkingen',
        'De keizerlijke garde gerekruteerd uit de zonen van onderworpen leiders',
        'De seizoensgebonden bijeenkomst waarop veldtochtplannen werden vastgesteld',
      ],
      0,
      'Estafetteruiters konden enkele honderden kilometers per dag afleggen. Marco Polo beschrijft het, en het verklaart voor een groot deel waarom het rijk überhaupt bestuurbaar was.',
    ],
    [
      'In welk decennium was de Russische verovering van de Centraal-Aziatische khanaten grotendeels voltooid?',
      ['De jaren 1880', 'De jaren 1850', 'De jaren 1900', 'De jaren 1820'],
      0,
      'Tasjkent viel in 1865, Samarkand in 1868, Chiva in 1873, en het Turkmeense verzet eindigde bij Geok Tepe in 1881.',
    ],
    [
      'Waar verwijzen de Kazachse zjoez-indelingen naar?',
      [
        'De drie grote horden - de Oudere, de Middelste en de Jongere',
        'De belastingdistricten die na de annexatie door het Russische bestuur werden ingesteld',
        'De seizoensgebonden migratieroutes van pastorale huishoudens',
        'De geestelijke hiërarchie van de Kazachse steppe onder Boecharaanse invloed',
      ],
      0,
      'Ze aanvaarden op verschillende momenten de Russische bescherming, wat voor een groot deel verklaart waarom de annexatie zich over een eeuw uitspreidde.',
    ],
    [
      'Wat was de belangrijkste oorzaak van de instorting van het Aralmeer in de twintigste eeuw?',
      [
        'Het aftakken van de Amu Darja en de Syr Darja voor geïrrigeerde katoenteelt',
        'Een regionale afname van de neerslag toe te schrijven aan klimaatverandering',
        'Tektonische inzakking die het afwateringsbekken veranderde',
        'Verdampingsverliezen door de aanleg van ondiepe stuwmeren',
      ],
      0,
      'Sovjetplanning voor katoen vanaf de jaren zestig. Het is de standaardcasus van een bewuste, voorziene milieuafweging in plaats van een ongeluk.',
    ],
    [
      'Welke van deze steden bereikten de veldtochten van Timoer?',
      [
        'Delhi, geplunderd in 1398',
        'Caïro, ingenomen na de nederlaag van de Mammelukken',
        'Constantinopel, belegerd maar niet ingenomen',
        'Wenen, bereikt tijdens de westelijke veldtocht van 1402',
      ],
      0,
      'Hij nam ook Damascus en Aleppo, en greep de Ottomaanse sultan bij Ankara in 1402 - maar nooit Caïro of Constantinopel.',
    ],
  ],
  phd: [
    [
      'Wat was het gevolg van de Slag bij Ankara in 1402?',
      [
        'Timoer greep Bayezid I, en de Ottomaanse staat viel in een interregnum van tien jaar',
        'De Ottomanen verloren hun Anatolische gebieden permanent aan de Timoeriden',
        'Constantinopel viel na een gezamenlijk Timoeridisch-Ottomaans beleg',
        'De Mammelukken annexeerden de Ottomaanse gebieden in Syrië',
      ],
      0,
      'Het stelde de val van Constantinopel een halve eeuw uit - het interregnum verklaart waarom Byzantium tot 1453 voortbestond.',
    ],
    [
      'Met welke heerser wordt de bekering van de Gouden Horde tot de islam geassocieerd?',
      [
        'Ozbeg Khan, in het begin van de veertiende eeuw',
        'Batoe, ten tijde van de westelijke veldtochten',
        'Berke, die zich er persoonlijk toe bekeerde zonder het officieel te maken',
        'Toktamysj, na zijn nederlaag tegen Timoer',
      ],
      0,
      'Berke had zich persoonlijk in de jaren 1250 bekeerd; Ozbeg maakte het tot staatsgodsdienst, wat een andere en veel ingrijpender stap is.',
    ],
    [
      'Waarvoor wordt Uloeg Beg vooral herinnerd?',
      [
        'Zijn observatorium in Samarkand en de daar samengestelde sterrencatalogus',
        'Zijn codificatie van het Timoeridische dynastieke recht na de dood van zijn grootvader',
        'Zijn bescherming van Chagatai-poëzie ten koste van het Perzisch',
        'Zijn veldtochten die het Timoeridische gezag over Chorasan herstelden',
      ],
      0,
      'De Zij-i Sultani gaf waarden voor het siderische jaar en de aardaskanteling die twee eeuwen lang de beste beschikbare bleven.',
    ],
    [
      'Waarin was het khanaat Kokand in de negentiende eeuw van belang?',
      [
        'De op de Ferghanavallei gebaseerde staat wiens expansie hem rechtstreeks in botsing bracht met de Russische opmars',
        'De belangrijkste Ottomaanse vazalstaat in Centraal-Azië, die wapens en erkenning uit Istanboel ontving',
        'De laatste overgebleven Chinggisidische dynastie in Transoxanië',
        'De belangrijkste tussenschakel in de Boecharaanse handel met Brits-Indië',
      ],
      0,
      'Het werd in 1876 volledig geannexeerd, in tegenstelling tot Boechara en Chiva, die tot 1920 als protectoraten voortbestonden.',
    ],
    [
      'Wat was de betekenis van de opstand van 1916 in Turkestan?',
      [
        'Een opstand tegen dwangarbeid in oorlogstijd, beantwoord met zware represailles en massale vlucht naar China',
        'De eerste georganiseerde bolsjewistische machtsovername in de regio',
        'Een opstand van Russische kolonisten tegen vorderingen door het keizerlijke bestuur',
        'Een religieuze opstand van soefi-ordes tegen de jadidistische hervormers',
      ],
      0,
      'Het dodental onder Kirgiezen en Kazakken en de vlucht naar Xinjiang maken het de grootste enkele episode van geweld in de regio vóór de collectivisatie.',
    ],
    [
      'Met welke dichter wordt de Chagatai-literaire taal vooral geassocieerd?',
      [
        'Ali-Sjir Nawa\'i',
        'Rudaki, aan het Samanidische hof',
        'Jami, schrijvend in Herat',
        'Babur, in zijn memoires',
      ],
      0,
      'Nawa\'i pleitte expliciet voor het Turks als literair gelijkwaardig aan het Perzisch. Babur schreef de Baburnama in het Chagatai, maar hij is niet de reden waarom de taal die status heeft.',
    ],
    [
      'Waarom waren de Transkaspische en Turkestaanse spoorlijnen van belang?',
      [
        'Ze maakten katoenmonocultuur en snelle troepenverplaatsing tegelijk mogelijk',
        'Ze openden de regio voor Europese in plaats van Russische fabrieksgoederen',
        'Ze vervingen de karavaanroutes door Perzië naar de Golf',
        'Ze verbonden de regio rechtstreeks met het Chinese spoornetwerk',
      ],
      0,
      'De spoorlijn maakte van een verovering een economische herschikking: rond 1915 voerde de regio graan in en vezels uit.',
    ],
    [
      'Wat deed de Sovjet-nationale afbakening van Centraal-Azië in 1924-36?',
      [
        'Zij verving de eenheden Turkestan en Boechara door republieken die op etnisch-linguïstische lijnen waren gedefinieerd',
        'Zij behield de vooroorlogse bestuurlijke grenzen onder nieuwe namen',
        'Zij creëerde één enkele Centraal-Aziatische federale republiek binnen de USSR',
        'Zij herstelde de grenzen van de khanaten van vóór de Russische verovering',
      ],
      0,
      'De grenzen die zij trok zijn de grenzen die de onafhankelijke staten in 1991 erfden, inclusief de enclaves in de Ferghanavallei.',
    ],
    [
      'Waardoor waren soefi-ordes in Centraal-Azië historisch vooral invloedrijk?',
      [
        'Door het netwerk van de Naqshbandiyya, dat religieus gezag met politieke macht verbond',
        'Door controle over het madrasacurriculum, ten koste van rechtsgeleerden',
        'Door hun monopolie op de financiering van langeafstandshandel',
        'Door hun rol als voornaamste schrijvers van de kanselarijen van de khanaten',
      ],
      0,
      'De sobere, wereldgerichte oriëntatie van de Naqshbandiyya is precies wat haar politiek bruikbaar maakte, zowel in Transoxanië als in Mogol-India.',
    ],
    [
      'Waarin onderscheiden de Kalmukken zich onder de volkeren van de Euraziatische steppe?',
      [
        'Zij zijn Oirat-Mongolen die naar het westen trokken en Tibetaans-boeddhistisch bleven',
        'Zij zijn de enige Turkse groep die tot in de moderne tijd een Chinggisidisch heersershuis behield',
        'Zij bekeerden zich tot de orthodoxie na indiensttreding bij de Russen',
        'Zij hielden tot 1917 een onafhankelijk khanaat in stand in de noordelijke Kaukasus',
      ],
      0,
      'Zij bereikten in de zeventiende eeuw de benedenloop van de Wolga, wat hen tot Europa\'s enige historisch boeddhistische volk maakt.',
    ],
  ],
  professor: [
    [
      'Waar draait het debat over "nomadische statenvorming" om?',
      [
        'Of steppevolken werden gedreven door interne dynamiek of door de noodzaak om van sedentaire buren te onttrekken',
        'Of pastoraal nomadisme voorafging aan of volgde op de invoering van gevestigde landbouw in de Euraziatische steppe',
        'Of steppelegers bestonden uit vrije herders of uit gedwongen dienstplichtigen',
        'Of steppe-opvolgingen werden bepaald door eerstgeboorterecht of door acclamatie',
      ],
      0,
      'Barfields argument van de spiegelrijken, tegen Kradin en anderen. Het is van belang omdat de extractieve lezing de steppe afhankelijk maakt en de interne lezing niet.',
    ],
    [
      'Waarom zijn de Sogdische Oude Brieven, gevonden bij Dunhuang, waardevol?',
      [
        'Het zijn particuliere handels- en familiecorrespondenties',
        'Ze bevatten de vroegst bekende Sogdische vertaling van boeddhistische geschriften',
        'Ze leggen de verdragsvoorwaarden tussen Sogdiana en de Tang vast',
        'Ze bewaren een compleet wetboek in een Midden-Iraanse taal',
      ],
      0,
      'Vierde-eeuwse brieven over schulden, goederen en een gestrande echtgenote. Ze laten zien hoe de handel echt werkte, wat geen kroniek doet.',
    ],
    [
      'Wat duidt de term "Turks-Perzisch" aan in de historiografie van de regio?',
      [
        'Een samengestelde politieke cultuur die Turkse militaire heerschappij combineert met Perzisch-georiënteerd bestuur en letteren',
        'Het taalkundige substraat dat Turkse en Iraanse talen van de regio gemeen hebben',
        'De dynastieke huwelijken tussen het Ottomaanse en Safavidische heersershuis, en de gedeelde hofcultuur die daaruit voortkwam',
        'De tweetalige kanselarijpraktijk van het Russische bestuur van Turkestan',
      ],
      0,
      'Canfields formulering. Ze beschrijft alles van de Ghaznaviden tot de Mogols, en verklaart waarom Perzisch de bestuurstaal was van rijken wier heersers Turks spraken.',
    ],
    [
      'Met welk complex wordt de archeologie van Gonur Depe in Turkmenistan geassocieerd?',
      [
        'Het Bactria-Margiana Archeologisch Complex uit het late derde en vroege tweede millennium voor Christus',
        'De Andronovo-horizon van de noordelijke steppe',
        'De Yaz-cultuur van de vroege ijzertijd, die het in dezelfde oases van Zuid-Turkmenistan opvolgde',
        'Het Achaemenidische provinciale bestuur van Margiana',
      ],
      0,
      'De opgravingen van Sarianidi. Of de BMAC een inheemse oasisbeschaving is of een Indo-Iraanse indringing, staat nog altijd niet vast.',
    ],
    [
      'Waarom zijn de Tocharische talen van het Tarimbekken van belang voor de historische taalkunde?',
      [
        'Ze zijn Indo-Europees maar tonen een nauwere verwantschap met westelijke takken dan met het nabijgelegen Indo-Iraans',
        'Ze vormen de oudste geattesteerde tak van de Indo-Iraanse familie',
        'Ze bewaren een pre-Indo-Europees substraat dat anders volledig verdwenen is uit het overgeleverde register van de regio',
        'Het zijn de enige Indo-Europese talen die in een Semitisch schrift zijn geschreven',
      ],
      0,
      'De centum-satem-anomalie: een centum-taal die ver oostelijk van elke andere ligt, wat precies verklaart waarom de mummies zoveel aandacht kregen.',
    ],
    [
      'Op welke grond wordt het concept "Pax Mongolica" bekritiseerd?',
      [
        'Het generaliseert vanuit een korte piek van veilige handel en onderschat de demografische prijs van de veroveringen',
        'Het schrijft aan de Mongolen een wegennet toe dat hen geheel voorafging',
        'Het steunt op Chinese bronnen die minstens enkele eeuwen na de betreffende periode zijn ontstaan',
        'Het verwart het Ilkhanaat met de Yuan op het punt van handelsbeleid',
      ],
      0,
      'Beide dingen zijn tegelijk waar - integratie en catastrofe - en de term selecteert er één, wat verklaart waarom hij steeds genuanceerd moet worden.',
    ],
    [
      'Waarvoor is het Manas-epos van belang?',
      [
        'Een omvangrijk Kirgizisch mondeling epos, waarvan de opgetekende versies honderdduizenden regels beslaan',
        'De Oezbeekse dynastieke kroniek van het huis Sjaybani',
        'Een Perzische versgeschiedenis van de Timoeridische opvolging, gecomponeerd aan het hof van Herat onder Sjah Roech',
        'Het vroegste geschreven document van het Kazachse gewoonterecht',
      ],
      0,
      'Langer dan de Ilias en de Odyssee samen. Het Sovjetbeleid ten aanzien van het epos wisselde tussen promotie als nationaal erfgoed en onderdrukking als feodaal-nationalistisch.',
    ],
    [
      'Waardoor kenmerkt zich het Qing-bestuur van Xinjiang na 1759?',
      [
        'Indirect bestuur via lokale begs onder militaire gouverneurs',
        'Onmiddellijke opname als gewone provincie naar het model van het binnenland',
        'Bestuur via het Lifanyuan, als schatplichtig gebied in plaats van als territorium',
        'Overdracht van gezag aan het khanaat Kokand als Qing-vazal',
      ],
      0,
      'Provinciale status kwam pas in 1884, na de opstand van Yaqub Beg en de herovering door Zuo Zongtang.',
    ],
    [
      'Wat markeert doorgaans het terminologische onderscheid tussen "Binnen-Aziatisch" en "Centraal-Aziatisch"?',
      [
        'Of Mongolië, Tibet en Xinjiang worden meegerekend naast de voormalige Sovjetrepublieken',
        'Of de regio wordt gedefinieerd door droogte of door pastoraal landgebruik',
        'Of het pre-islamitische of post-islamitische tijdvak wordt besproken',
        'Of de analyse taalkundig of archeologisch van methode is',
      ],
      0,
      'Het is geen haarkloverij: het bredere kader maakt de Qing en de Russische rijken vergelijkbare gevallen, en het smallere niet.',
    ],
    [
      'Waarom worden de negentiende-eeuwse reisverslagen van Vambery en Schuyler met voorzichtigheid gebruikt?',
      [
        'Beide werden geschreven om het keizerlijke beleid te informeren',
        'Geen van beide auteurs bezocht de door hem beschreven steden zelf',
        'Beide zijn alleen in sterk bewerkte latere vertalingen bewaard gebleven',
        'Beide steunden bijna volledig op Russische officiële statistieken',
      ],
      0,
      'Vambery reisde vermomd en dong naar de gunst van de Britse gevestigde orde; Schuyler was een Amerikaanse diplomaat. De waarneming is vaak goed en het kader nooit neutraal.',
    ],
  ],
};
